// @ts-nocheck

import axios from "axios";
import { useEffect, useState } from "react";
import Select from "react-select";
import useStore from "../../store/useStore";
import { customStyleSelectCards } from "../../styles/styleSelect";

interface SelectProps {
  value: string;
  label: string;
}
export function InputPlacaCarro() {
  const [costCenterOpt, setCostCenterOpt] = useState<SelectProps[]>([
    { value: "RVU6D37", label: "RVU6D37" },
  ]);
  const { setSelecionaPlacaCarro, selecionaPlacaCarro } = useStore((state) => state);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await axios.get(
          "https://radar.tlpservicos.com.br/api/tracking/all-vehicles"
        );
        setCostCenterOpt(
          data.placas.map((item: string) => ({
            value: item,
            label: item,
          }))
        );
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <div className=" bg-gray-50 dark:bg-gray-350 rounded-lg h-full flex flex-col overflow-visible">
      <div className=" bg-gray-100 dark:bg-gray-400 h-6 drag-handle cursor-move flex items-center px-2 rounded-t-md font-semibold text-sm">
        Placa
      </div>
      <div className="flex-grow flex flex-col justify-center px-1">
        <Select
          options={costCenterOpt}
          styles={customStyleSelectCards<SelectProps>()}
          placeholder="placas disponíveis"
          isClearable
          isSearchable
          className="rounded-lg w-full text-sm"
          classNamePrefix="select"
          noOptionsMessage={() => "Nenhuma placa encontrada"}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultValue={selecionaPlacaCarro}
          onChange={setSelecionaPlacaCarro}
        />
      </div>
    </div>
  );
}
